'use strict';

var App = App || {};

App.GalleryOverlay = function () {
  'use strict';

  /**
   * Holds an instance of the current AJAX request
   */

  var activeAjaxRequest = null;

  /**
   * This is the URL GET variable that is looked for on page load to automatically trigger a gallery
   * if one is specified
   * @type {String}
   */
  // var urlGalleryTrigger = 'gallery';

  /**
   * Holds an array of objects containing bound keys and associated event listeners so they can be
   * removed when a gallery overlay is closed.
   * @type {Array}
   */
  var keyboardEventListeners = [];

  /**
   * Holds instance of Slick slider for main gallery
   */
  var $galleryOverlaySlides;

  var initialize = function initialize() {
    _initializeUiButtons();
    // Initialize all gallery squares on page load and bind behaviors to links.
    _bindFeatureTileLink();
    // _viewGalleryOnload();
  };

  /**
   * Handles automatically opening a galllery when one is specified in the URL
   * @return {void}
   */
  // var _viewGalleryOnload = function() {

  //   var urlData = {},
  //       currentUrl = window.location.toString(),
  //       urlComponents = currentUrl.split('?'),
  //       getVars = urlComponents[1],
  //       urlBase = urlComponents[0],
  //       galleryName = null;

  //   if (!getVars) return

  //   getVars = getVars.replace(/([#])\w+/, '').split('&')

  //   // Loop over GET key/val pairs
  //   // If a key that matches the url gallery trigger matches, pull the value
  //   //
  //   for (let getVar of getVars) {
  //     var [key, val] = getVar.split('=')

  //     // Retrieve any GET vars from URL, remove hash if it exists, split vars present, separate to a
  //     // ke/value urlData object property and value
  //     if (key === urlGalleryTrigger) {
  //       galleryName = decodeURIComponent(val);
  //       _ajaxGalleryContent(urlBase + galleryName + '/')
  //       break;
  //     }
  //   }
  // }

  //=============== Code that handles on page triggering/ajax to load content and trigger the overlay.
  var _bindFeatureTileLink = function _bindFeatureTileLink() {
    $(document).on('click', '.js-trigger-gallery-overlay', function (e) {
      e.preventDefault();
      var href = $(this).attr("href");

      _showGalleryOverlay();
      _ajaxGalleryContent(href);
    });
  };

  /**
   * Toggles loading overlay visibility
   * @return {void} [description]
   */
  // var _toggleLoadingOverlay = function() {
  //   $('.loading-overlay').is(':visible') ? _hideLoadingOverlay() : _showLoadingOverlay()
  // };

  /**
   * Hides the loading overlay
   * @return {void}
   */
  var _hideLoadingOverlay = function _hideLoadingOverlay() {
    $('.loading-overlay').velocity('fadeOut', function () {
      $('.gallery-overlay-content').empty();
    });
  };

  /**
   * Shows the loading overlay
   * @return {void}
   */
  var _showLoadingOverlay = function _showLoadingOverlay() {
    $('.loading-overlay').velocity('fadeIn');
  };

  /**
   * Shows a gallery
   * @return {void}
   */
  var _showGalleryOverlay = function _showGalleryOverlay() {
    $('.gallery-overlay-container').velocity("fadeIn");
  };

  var _ajaxGalleryContent = function _ajaxGalleryContent(resourceUrl) {
    activeAjaxRequest = $.ajax({
      async: true,
      url: resourceUrl,
      type: 'GET',
      dataType: 'html',
      beforeSend: function beforeSend() {
        // Prevents conflicting requests
        if (activeAjaxRequest) {
          activeAjaxRequest.abort();
          activeAjaxRequest = null;
        }
      }
    }).success(function (content) {
      console.log("Request complete.");
      $('.gallery-overlay-content').html(content);
      _initializeOverlay();
    }).fail(function () {
      console.log("error");
    }).always(function () {});
  };

  // ============== Code that handles functions for the overlay window itself.
  var _initializeOverlay = function _initializeOverlay() {
    $('body').addClass('gallery-overlay-visible');
    // This is called when the content has been AJAX'd in.
    // Wait for the first image to be preloaded, then init the slides
    _bindGalleryOverlayClose();
    _bindEscapeClose();

    console.log('before setTimeout');
    setTimeout(function () {
      console.log('setTimeout fired');

      $('.gallery-overlay-slides .gallery-overlay-slide:first').imagesLoaded(function () {
        console.log('first image loaded');
        _createPortfolioSlides();
        _createPortfolioControlSlides();
        _setSlideIncrementControls();
        _initGalleryDrawerClosed();
        _makeGalleryDrawerResponsive();
        _bindProgressIndicator();
        _setMainSliderFocus();

        $('.gallery-overlay-content').velocity({ opacity: 1 });
      });
    }, 150);
  };

  var _initializeUiButtons = function _initializeUiButtons() {
    // These behaviors only need to be bound to the element once.
    // Binding the gallery nav drawer button (arrow down/up) more than once creates a multiplying animation queue every time a new overlay gallery is opened.
    _bindGalleryNavDrawerToggle();
  };

  /**
   * Hides loading overlay when gallery is finished loading
   * @return {void}
   */
  var _preLoadAssets = function _preLoadAssets() {
    $('.gallery-overlay-container').imagesLoaded(function () {
      _hideLoadingOverlay();
    });
  };

  /**
   * Initialize the portfolio slider
   * @return {void}
   */
  var _createPortfolioSlides = function _createPortfolioSlides() {
    $galleryOverlaySlides = $('.gallery-overlay-slides').slick({
      fade: true,
      infinite: true,
      asNavFor: ".gallery-nav-slides"
    });
  };

  /**
   * Initialize the control slides
   * @return {void}
   */
  var _createPortfolioControlSlides = function _createPortfolioControlSlides() {
    // Retest this and set the appropriate amount of slides for a given window size (breakpoints)
    $('.gallery-nav-slides').slick({
      arrows: false,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.gallery-overlay-slides',
      focusOnSelect: true,
      mobileFirst: true,
      responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }]
    });
  };

  /**
   * Binds forward/back buttons if more than one slide is present
   */
  var _setSlideIncrementControls = function _setSlideIncrementControls() {
    if ($('.gallery-overlay-slides .slick-slide').length > 1) {
      _bindSlideControlPrev();
      _bindSlideControlNext();
    } else {
      $('.gallery-title-bar').addClass('no-increment-controls');
    }
  };

  /**
   * Binds the escape key to closing gallery overlay
   * @return {void}
   */
  var _bindEscapeClose = function _bindEscapeClose() {
    document.addEventListener('keydown', _escapeKeyHandler);
  };

  var _unbindEscapeClose = function _unbindEscapeClose() {
    document.removeEventListener('keydown', _escapeKeyHandler);
  };

  /**
   * Hndles closing the gallery if the event passed is an esc keypress
   * @param  {event} e Event from the event listener
   * @return {void}
   */
  var _escapeKeyHandler = function _escapeKeyHandler(e) {
    e.which === 27 && _galleryOverlayClose();
  };

  /**
   * Binds previous slide buttons
   * @return {void}
   */
  var _bindSlideControlPrev = function _bindSlideControlPrev() {
    $(document).on('click', '.js-gallery-nav-slides-prev', function (e) {
      e.preventDefault();
      $galleryOverlaySlides.slick("slickPrev");
      _setMainSliderFocus();
    });
  };

  /**
   * Binds next slide buttons
   * @return {void}
   */
  var _bindSlideControlNext = function _bindSlideControlNext() {
    $(document).on('click', '.js-gallery-nav-slides-next', function (e) {
      e.preventDefault();
      $galleryOverlaySlides.slick("slickNext");
      _setMainSliderFocus();
    });
  };

  /**
   * Updates the current slide counter
   * @return {void}
   */
  var _bindProgressIndicator = function _bindProgressIndicator() {
    $galleryOverlaySlides.on('afterChange', function (e, slick, currentSlide) {
      $('.gallery-progress .current').text(currentSlide + 1);
    });
  };

  /**
   * Binds nav drawer toggle
   * @return {void}
   */
  var _bindGalleryNavDrawerToggle = function _bindGalleryNavDrawerToggle() {
    $(document).on('click', '.js-toggle-gallery-drawer', function (e) {
      e.preventDefault();
      _toggleGalleryDrawer();
      _setMainSliderFocus();
    });
  };

  /**
   * Puts focus on current slide in main gallery. This enables keyboard slide navigation
   */
  var _setMainSliderFocus = function _setMainSliderFocus() {
    $('.gallery-overlay-slides .slick-active').focus();
  };

  /**
   * Binds gallery close button
   * @return {void}
   */
  var _bindGalleryOverlayClose = function _bindGalleryOverlayClose() {
    $(document).on('click', '.js-close-gallery-overlay', function (e) {
      e.preventDefault();
      _galleryOverlayClose();
    });
  };

  /**
   * Closes the active gallery overlay
   * @return {void}
   */
  var _galleryOverlayClose = function _galleryOverlayClose() {
    $('.gallery-overlay-container').velocity('fadeOut', function () {
      _unbindEscapeClose();
      $('.gallery-overlay-content').empty();
      $('body').removeClass('gallery-overlay-visible');
      $('.gallery-overlay-content').css({ opacity: 0 });
    }, 300);
  };

  /**
   * Shows/hides gallery nav drawer
   * @return {void}
   */
  var _toggleGalleryDrawer = function _toggleGalleryDrawer() {
    var $galleryOverlayDrawer = $('.gallery-overlay-drawer'),
        $buttonToggleDrawer = $('.button-toggle-drawer'),
        $galleryNavDrawer = $('.gallery-nav-drawer'),
        navDrawerHeight,
        navDrawerBottomCss,
        isOpen,
        slideDir;

    $galleryOverlayDrawer.toggleClass("closed");
    $buttonToggleDrawer.toggleClass("down up");

    // This doesn't use the slideDown/slideUp animation. It
    // It interferes with rendering the nav slides after clicking a slide next or prev when the drawer is closed. No idea why...
    // This gets the height of the nav slides container then changes the position of the gallery-overlay-drawer.
    if ($galleryOverlayDrawer.hasClass("closed")) {
      _setGalleryDrawerClosed();
    } else {
      $galleryOverlayDrawer.velocity({ bottom: 0 });
    }
  };

  /**
   * Resizes/positions gallery drawer on window resize
   * @return {void}
   */
  var _makeGalleryDrawerResponsive = function _makeGalleryDrawerResponsive() {
    var resizeTimer;

    window.onresize = function () {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(function () {
        if ($('.gallery-overlay-drawer').hasClass("closed") || Foundation.MediaQuery.is("small only")) {
          _initGalleryDrawerClosed();
        }
      }, 250);
    };
  };

  /**
   * Calculates the height of the nav drawer. Returns in px
   * @return {string} Height of nav drawer in px
   */
  var _getNavDrawerHeight = function _getNavDrawerHeight() {
    return ($('.gallery-nav-drawer').height() + 1) * -1 + "px";
  };

  /**
   * Closes the gallery nav drawer
   * @return {void}
   */
  var _setGalleryDrawerClosed = function _setGalleryDrawerClosed() {
    $('.gallery-overlay-drawer').velocity({ bottom: _getNavDrawerHeight() });
  };

  /**
   * Handles showing/hiding drawer on initialization
   * @return {void}
   */
  var _initGalleryDrawerClosed = function _initGalleryDrawerClosed() {
    var $galleryOverlayDrawer = $('.gallery-overlay-drawer');

    if (Foundation.MediaQuery.is("small only")) {
      $galleryOverlayDrawer.css({ bottom: 0 });
    } else {
      $galleryOverlayDrawer.css({ bottom: _getNavDrawerHeight() });
    }
  };

  return {
    initialize: initialize
  };
}();